"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {
    form: {
      type: Object,
      default: {}
    },
    name: {
      type: String,
      default: 'agent'
    }
  },
  data: function data() {
    return {
      week: ['日', '一', '二', '三', '四', '五', '六']
    };
  },
  mounted: function mounted() {},
  methods: {}
};